export default __webpack_public_path__ + "static/media/NOMOR 1 SALAH.245ead05.png";